package org.hs_soft.runmynesto.domain.model.home.closing_reports.closing_report_model


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import org.hs_soft.runmynesto.domain.model.general_error_model.GeneralError

@Serializable
data class ClosingReportsModel(
    @SerialName("data")
    val `data`: Data?,
    @SerialName("errors")
    val errors: List<GeneralError?>?=null,
)